<div class="container">

    <div class="row" *ngIf="hideCard == false" style="padding-top: 5%; 
    padding-bottom: 20%;">
        <div class="col-lg-4" (click)="cardhide()" style="    padding-top: 35px;">
            <div class="card cardborder card2" style="    height: 185px;">
                <div class="card-body">
                    <div class="box">
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3gMfFBUB8Kc3yAAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAABmJLR0QA/wD/AP+gvaeTAAAAP0lEQVRYw+3UsQkAMAwDsPz/o29pHkjnlCKDV6PJVb8myZkKBgYGBgYGBvYg7Da+VTAwMD8GBgYGBgYGBraWBpeqjFTlGtDAAAAAAElFTkSuQmCC"
                            alt="">
                        <h2 style="font-size: 22px;    margin-top: 25px;">Add Address</h2>
                    </div>
                </div>

            </div>

        </div>


        <div class="col-lg-4" *ngFor="let data of cusAddress" style="    padding-top: 35px;">
            <div class="card  cardborder1">
                <div class="card-body " style="padding: 10px;">
                    <div class="box1 lineborder">
                        <h1 style="font-size: 15px;">{{data.name}} <span *ngIf="data.iscurrentaddress == true"
                                style="color: red;    margin-left: 20px;    font-size: 11px;">Default</span></h1>

                    </div>
                    <div style="height: 80px;margin-top: 5px;">
                        <span style="font-size: 15px;">{{data.address}}
                        </span><br>
                        <span style="font-size: 15px;"> {{data.city}}-{{data.pincode}}</span><br>

                        <span style="font-size: 15px;">{{data.landMark}}</span><br>
                    </div>

                    <div class="row" style="    margin-top: 25px;">
                        <div class="col-3" style="text-align: center;">
                            <a href="javascript:;" (click)="EditCustomer(data)" style="color: #ff4c3b;"> Edit</a>
                        </div>
                        <div class="col-1">
                            <a> |</a>
                        </div>
                        <div class="col-3" style="text-align: center;">
                            <a style="color: #ff4c3b;" href="javascript:;" (click)="remove(data)"> Remove</a>
                        </div>
                        <div class="col-1" *ngIf="data.iscurrentaddress == false">
                            <a> |</a>
                        </div>
                        <div class="col-3" *ngIf="data.iscurrentaddress == false" style="text-align: center;">
                            <a style="color: #ff4c3b;" href="javascript:;"
                                (click)="selectCustomerAddress(data.customerId,data.id)"> Set Default</a>
                        </div>
                    </div>

                </div>

            </div>

        </div>

    </div>


    <div class="checkout-page" *ngIf="hideCard == true">
        <div class="checkout-form">

            <div class="row">
                <div class="col-lg-3 col-sm-12 col-xs-12"></div>
                <div class="col-lg-8 col-sm-12 col-xs-12">

                    <div class="checkout-details" style="margin-bottom: 20px;">

                        <div class="order-box">
                            <div class="col-md-12 row">
                                <div class="col-md-6">
                                    <div class="checkout-title">
                                        <h3>Billing Details</h3>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <!-- <button *ngIf="checkvalue == 2" type="submit" class="btn btn-solid p-1"
                                        style="margin-left: 20%;" (click)="NewCustomer()">
                                        Choose Customer
                                    </button> -->
                                </div>
                            </div>

                            <form [formGroup]="checkoutForm" (ngSubmit)="onSubmit()">
                                <div class="row check-out">
                                    <!-- Name Field -->
                                    <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                        <div class="field-label">Name <span class="text-danger">*</span></div>
                                        <input type="text" formControlName="name" placeholder="Enter Name"
                                            autocomplete="off" maxlength="25"
                                            (keypress)="validateAlphabeticInput($event)" />
                                        <div *ngIf="checkoutForm.controls.name.touched && checkoutForm.controls.name.errors?.required"
                                            class="text text-danger">
                                            Name is required.
                                        </div>
                                    </div>

                                    <!-- Alternate Phone Field -->
                                    <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                        <div class="field-label">Alternate Phone <span class="text-danger">*</span>
                                        </div>
                                        <input type="text" formControlName="phone" placeholder="Enter Phone Number"
                                            autocomplete="off" maxlength="10"
                                            (keypress)="phonevalidateNumericInput($event)" />
                                        <div *ngIf="checkoutForm.controls.phone.touched && checkoutForm.controls.phone.errors?.required"
                                            class="text text-danger">
                                            Phone No is required.
                                        </div>
                                        <div *ngIf="checkoutForm.controls.phone.touched && checkoutForm.controls.phone.errors?.pattern"
                                            class="text text-danger">
                                            Phone No must be a valid number.
                                        </div>
                                    </div>

                                    <!--state Field-->
                                    <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                        <div class="field-label">State <span class="text-danger">*</span></div>
                                        <select formControlName="state" class="form-control"
                                            (change)="onStateChange($event)">
                                            <option value="" disabled selected>Select a state</option>
                                            <option value="Tamil Nadu">Tamil Nadu</option>
                                            <option value="Andhra Pradesh">Andhra Pradesh</option>
                                            <option value="Telangana">Telangana</option>
                                            <option value="Karnataka">Karnataka</option>
                                            <option value="Pondicherry">Pondicherry</option>
                                        </select>
                                        <div *ngIf="checkoutForm.controls.state.touched && checkoutForm.controls.state.errors?.required"
                                            class="text text-danger">State is required.</div>
                                    </div>
                                    <!-- City Field -->
                                    <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                        <div class="field-label">City <span class="text-danger">*</span></div>
                                        <select formControlName="city" class="form-control"
                                            [disabled]="checkoutForm.controls.city.disabled"
                                            (change)="changecity($event)">
                                            <option value="" disabled selected>Select a city</option>
                                            <option *ngFor="let city of cities" [value]="city">{{ city }}</option>
                                        </select>
                                        <div *ngIf="checkoutForm.controls.city.touched && checkoutForm.controls.city.errors?.required"
                                            class="text text-danger">City is required.</div>
                                    </div>




                                    <!-- Postal Code Field -->
                                    <!-- <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                        <div class="field-label">Postal Code <span class="text-danger">*</span>
                                        </div>
                                        <input type="text" formControlName="postalcode"
                                            placeholder="Enter Postal Code" autocomplete="off" maxlength="6"
                                            (keypress)="validateNumericInput($event)" />
                                        <div *ngIf="checkoutForm.controls.postalcode.touched && checkoutForm.controls.postalcode.errors?.required"
                                            class="text text-danger">
                                            Postal Code is required.
                                        </div>
                                    </div> -->


                                    <!-- 
                                    <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                        <div class="field-label">Postal Code <span class="text-danger">*</span></div>
                                        <input type="text" formControlName="postalcode"
                                               placeholder="Enter Postal Code" autocomplete="off" maxlength="6"
                                               (keypress)="validatepostalinput($event)" (blur)="validatePostalCode()" />
                                      
                                        <div *ngIf="checkoutForm.controls.postalcode.touched && checkoutForm.controls.postalcode.errors?.required"
                                             class="text text-danger">
                                          Postal Code is required.
                                        </div>
                                      
                                        <div *ngIf="maduraiDeliveryError" class="text text-danger">
                                          Madurai delivery is not possible.
                                        </div>
                                      
                                        <div *ngIf="checkoutForm.controls.postalcode.touched && checkoutForm.controls.postalcode.errors?.pattern"
                                             class="text text-danger">
                                          Invalid Postal Code. Please enter a valid postal code starting with 5 or 6.
                                        </div>
                                      </div> -->


                                    <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                        <div class="field-label">Postal Code <span class="text-danger">*</span>
                                        </div>
                                        <input type="text" formControlName="postalcode" placeholder="Enter Postal Code"
                                            autocomplete="off" maxlength="6" (keypress)="validateNumericInput($event)"
                                            (blur)="validatePostalCode()" />
                                        <div *ngIf="checkoutForm.controls.postalcode.touched && checkoutForm.controls.postalcode.errors?.required"
                                            class="text text-danger">Postal Code is required.</div>


                                        <!-- <div *ngIf="maduraiDeliveryError" class="text text-danger">
                                            Madurai delivery is not possible.
                                          </div> -->

                                        <div *ngIf="checkoutForm.controls.postalcode.touched && checkoutForm.controls.postalcode.errors?.pattern"
                                            class="text text-danger">
                                            invalid Postal Code
                                        </div>
                                    </div>









                                    <!-- <div *ngIf="maduraiCityError" class="text text-danger">
                                          Delivery not available for Madurai.
                                        </div> -->


                                    <!-- Address Field -->
                                    <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                        <div class="field-label">Address <span class="text-danger">*</span></div>
                                        <textarea formControlName="address" rows="2" placeholder="Enter Address"
                                            style="padding: 10px 22px;" autocomplete="off" maxlength="150"></textarea>
                                        <div *ngIf="checkoutForm.controls.address.touched && checkoutForm.controls.address.errors?.required"
                                            class="text text-danger">Address is required.</div>
                                        <div *ngIf="checkoutForm.controls.address.touched && checkoutForm.controls.address.errors?.minlength"
                                            class="text text-danger">Address must be at least 10 characters long.
                                        </div>
                                        <!-- <div *ngIf="maduraiCityError" class="text text-danger">
                                          Delivery not available for Madurai locations.
                                        </div> -->
                                    </div>

                                    <!-- Landmark Field -->
                                    <div class="form-group col-md-12 col-sm-6 col-xs-12">
                                        <div class="field-label">Landmark (Optional)</div>
                                        <input type="text" formControlName="landmark" placeholder="Enter Landmark"
                                            autocomplete="off" maxlength="50" />
                                    </div>

                                    <!-- Delivery Checkbox -->
                                    <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                        <div class="field-label btn-toolbar">

                                            <div>
                                                <span> Delivery Here :</span>
                                            </div>
                                            <div>
                                                <input type="checkbox" formControlName="iscurrentaddress"
                                                    (change)="changefilter($event.target.checked)"
                                                    style="height: 18px;margin-top: 4px;    margin-left: 10px;" />
                                            </div>


                                        </div>
                                    </div>


                                    <div class="text-end col-md-6 col-sm-6 col-xs-12">
                                        <button type="submit" id="save-btn" *ngIf="EditId === 0" class="btn-solid btn"
                                            style="margin-right: 25px;" [disabled]="checkoutForm.invalid">
                                            Save
                                        </button>

                                        <button id="update-btn" *ngIf="EditId > 0" type="submit" class="btn-solid btn"
                                            style="margin-right: 25px;" [disabled]="!checkoutForm.valid"
                                            data-testid="update-button">
                                            Update
                                        </button>
                                        <button id="back-btn" type="button" class="btn-solid btn" (click)="backcard()"
                                            data-testid="back-button">
                                            Back
                                        </button>
                                    </div>
                                    <!-- Save Button -->
                                    <!-- <div class="text-end col-md-6 col-sm-6 col-xs-12">
                                            <button type="submit" 
                                                    id="save-btn" 
                                                    aria-label="Save Data"
                                                    class="btn-solid btn"
                                                    [disabled]= "!isValidAddress(userAddress)">
                                              Save
                                              </button>
                                          </div> -->

                                    <!-- Message if address contains Madurai -->
                                    <!-- <div *ngIf="isAddressFromMadurai(userAddress)" class="error-message">
                                              Sorry, we do not deliver to Madurai.
                                            </div>
                                          </div> 
                                          
                                          
-->

                                </div>
                            </form>

                        </div>
                    </div>
                </div>



            </div>

        </div>
    </div>
</div>








<ng-template #DeleteModel let-modal>
    <div class="modal-body">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="modal-body">

                    <div class="icon-box">
                        <span style="color: red;    font-size: 35px;"><i class="fa fa-trash-o" aria-hidden="true"
                                style="    margin-top: 20px;"></i></span>
                    </div>
                    <h4 class="modal-title w-100" style="    text-align: center;
                    margin-top: 20px;">Are you sure?</h4>

                    <p style="text-align: center;
                    margin-top: 10px;">Do you really want to delete these Address?</p>

                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-theme btn-sm" data-dismiss="modal" id="cancel-btn"
                        aria-label="cancel Data" (click)="modal.dismiss('Cross click')">Cancel</button>
                    <button type="button" class="btn btn-theme btn-sm" id="delete-btn" aria-label="delete Data"
                        (click)="DeleteAddress()">Delete</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>



<div style="display: none;" id="preloaderaddcus">
    <!-- <img  alt=""> -->
    <div id="loaderaddcus">
        <div class="loaderzig">
            <div class="loader__part loader__part--1"></div>
            <div class="loader__part loader__part--2"></div>
            <div class="loader__part loader__part--3"></div>
        </div>
    </div>
</div>





<ng-template #errorModal let-modal>
    <div class="modal-body">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="modal-body"
                    style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; padding: 0;">

                    <!-- Centered icon box -->
                    <!-- Centered icon box -->
                    <div class="icon-box text-center"
                        style="position: relative; display: inline-block; width: 100px; height: 100px; background-color: #f0f0f0; border-radius: 50%; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;">
                        <i class="fa fa-frown-o" aria-hidden="true" style="font-size: 100px; color: red;"></i>
                    </div>


                    <!-- Message Text -->
                    <p style="text-align: center; margin-top: 10px; font-size: 16px; font-weight: 700;">
                        sorry! Order is not available for your location. Below are some nearby stores with their contact
                        details:
                    </p>

                    <!-- Table for Store Details -->
                    <div class="row">
                        <!-- Store 1 -->
                        <div class="col-lg-6">
                            <div class="card" style="margin-bottom: 20px;">
                                <div class="card-body">
                                    <h5 class="card-title">Keelavasal</h5>
                                    <p class="card-text">Address: 257 kamarajar salai, Madurai</p>
                                    <p class="card-text">Contact: 7339073370</p>
                                </div>
                            </div>
                        </div>

                        <!-- Store 2 -->
                        <div class="col-lg-6">
                            <div class="card" style="margin-bottom: 20px;">
                                <div class="card-body">
                                    <h5 class="card-title">AnnaNagar-Madurai</h5>
                                    <p class="card-text">Address: Meenatchi Towers, 188, 80FeetRd, AnnaNagar</p>
                                    <p class="card-text">Contact: 9566795888</p>
                                </div>
                            </div>
                        </div>

                        <!-- Store 3 -->
                        <div class="col-lg-6">
                            <div class="card" style="margin-bottom: 20px;">
                                <div class="card-body">
                                    <h5 class="card-title">ThabaalThanthiNagar</h5>
                                    <p class="card-text">Address: 65, Meenakshi Nagar Rd, Thabaal Thanthi Nagar</p>
                                    <p class="card-text">Contact: 8807210111</p>
                                </div>
                            </div>
                        </div>

                        <!-- Store 4 -->
                        <div class="col-lg-6">
                            <div class="card" style="margin-bottom: 20px;">
                                <div class="card-body">
                                    <h5 class="card-title">k.pudhur</h5>
                                    <p class="card-text">Address: Plot No.8, AB Tower, Karpaga Nagar, K.pudhur</p>
                                    <p class="card-text">Contact: 9500040111</p>
                                </div>
                            </div>
                        </div>

                        <!-- Store 5 -->
                        <div class="col-lg-6">
                            <div class="card" style="margin-bottom: 20px;">
                                <div class="card-body">
                                    <h5 class="card-title">BB.kulam</h5>
                                    <p class="card-text">Address: No 11 Vishaal Heights, V.P. Rathinasamy Nadar Rd, BB
                                        kulam</p>
                                    <p class="card-text">Contact: 9500086111</p>
                                </div>
                            </div>
                        </div>

                        <!-- Store 6 -->
                        <div class="col-lg-6">
                            <div class="card" style="margin-bottom: 20px;">
                                <div class="card-body">
                                    <h5 class="card-title">villapuram</h5>
                                    <p class="card-text">Address: 49, Aruppukottai MainRoad, villapuram</p>
                                    <p class="card-text">Contact: 9500028111</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer"
                    style="display: flex; justify-content: center; width: 100%; border-top: none; padding: 0;">
                    <button type="button" class="btn btn-theme btn-sm" data-dismiss="modal" id="cancel-btn"
                        aria-label="cancel Data" (click)="modal.dismiss('Cross click')">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>